import styled, { css } from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'

export const StyledFilter = styled.div`
  font-size: 12px;
  font-weight: bold;
  line-height: 26px;
  margin: auto 20px;
  text-align: center;
  padding: 2px 10px;
  color: ${colors.WHITE};
  background-color: ${colors.MEDIUM_GRAY};
  border-radius: 100px;
`;

export const FilterButton = styled.button`
  padding: 0 5px;
  > svg {
    fill: ${colors.LIGHT_GRAY};
    margin: 0px 0px 2px;
  }
`;

export const StyledEmptyList = styled.div`
  text-align: center;
  color: rgba(104,129,144,0.6);

  > svg {
    fill: ${colors.GRAY};
  }
  >a {
    > button {
      font-size: 12px;
    }
  }
`;

export const EmptyText = styled.p`
  padding-bottom: 40px;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #E7EBEC;

  + tr {
    border-top: solid 1px #E7EBEC;
  }
`;

const tableCellStyles = css`
  padding: 18px 0;
  width: 288px;
  margin-right: 0px;
  ${({ isNumber }) => isNumber && `
    width: 60px;
  `}

  &:first-child {
    width: 204px;
    margin-right: 20px;
  }

  &:nth-child(2) {
    ${media.desktop`
      width: 204px;
    `}

    ${media.tablet`
      width: 204px;
    `}

    ${media.mobile`
      width: 195px;
    `}
  }

  &:nth-child(3) {
    ${media.desktop`
      width: 156px;
    `}
    ${media.tablet`
      width: 217px;
    `}
    ${media.mobile`
      display:none;
    `}
  }

  &:last-child {
    padding-right: 20px;
    width: 220px;
      ${media.desktop`
        padding-right: 0px;
      `}

      ${media.tablet`
        padding-right: 0px;
      `}
      ${media.mobile`
        padding-right: 0px;
      `}
  }
`;

export const TableData = styled.div`
  ${tableCellStyles}
  ${({ isLink }) => isLink && `
    &:hover {
      cursor: pointer;
      text-decoration: underline;
      color: ${colors.MAIN_COLOR};
    }
  `}

  ${({ isIcon }) => isIcon && `
    text-align: right;
    min-width: inherit;
  `}

  ${({ isActive }) => typeof(isActive) === "boolean" && `
    span {
      margin-right: 18px;
      display: block;
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: #${isActive ? '0CFF00' : 'E7EBEC'};
    }
  `}

  > a > svg {
    fill: ${colors.LIGHT_GRAY};
  }
`;

export const Wrapper = styled.div`
  padding-bottom: 3em;
`;

export const Title = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button`
  margin: 10px 30px;
  color: #183748;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 14px;

  &:hover {
    color: ${colors.MAIN_COLOR};
  }
`;

export const TableWrapper = styled.div`
  text-align: center;
  margin-top: 18px;
`;

export const StyledTable = styled.table`
  width: 100%;
  empty-cells: show;
  background-color: ${colors.WHITE};
  text-align: left;
`;

export const TableHead = styled.thead`
  > tr {
    height: 40px;
    text-align: left;

    th {
      color: ${colors.DARK};
      font-size: 8px;
      font-weight: bold;
      letter-spacing: 2px;
      line-height: 14px;
      text-transform: uppercase;
      padding-bottom: 10px;
    }
  }
`;

export const TableHeader = styled.th`${tableCellStyles}`;

export const TableBody = styled.tbody`
  > tr {
    border-bottom: 1px solid #E7EBEC;
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    height: 60px;
    color:  ${colors.BODY};
  }
`;

export const StatusFilterList = styled.div`
  display: flex;
  width:100%;
  margin-top: 40px;
`;

export const StatusFilterOption = styled.div`
  cursor: pointer;
  color: #B9C3C8;
  font-size: 10px;
  font-weight: normal;
  font-family: poppins, sans-serif;
  letter-spacing: 2px;
  text-transform: uppercase;
  height: 14px;
  line-height: 14px;
  margin: 0.5em 2em;

  &:first-of-type {
    margin-left: 0;
  }

  &.active,
  &:hover  {
    color: black;
  }
`;

export const StatusFilterOptionItem = styled.div`
  box-shadow: 0 2px 0 0 ${({ isActive }) => isActive ? colors.ACTIVE_COLOR : 'transparent'};
  padding: 0 0 0.5em 0;
`;

export const RowHyperlink = styled.a`
  color: ${colors.MAIN_COLOR};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    color: ${colors.MAIN_COLOR};
  }
`;


// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/ChannelList/styledComponents.js